/*
 * Шалгалтын суурь — жинхэнэ домэйн биш. Харьцангуй зам энэ суурийг
 * СОЛИВОЛ (origin өөрчлөгдвөл) тэр нь гадаад хаяг гэсэн үг.
 */
const PROBE_ORIGIN = 'http://next.invalid'

/**
 * Нэвтэрсний дараа очих замыг шүүнэ: зөвхөн ЭНЭ сайтын харьцангуй зам,
 * бусад бүх тохиолдолд `/`.
 *
 * ! 🔴 НЭЭЛТТЭЙ ЧИГЛҮҮЛЭЛТ (INJ-3 / FE-02). `next` нь ХАЯГНААС ирдэг тул
 * ! халдагч утгыг нь бичнэ. Хуучин «`/`-ээр эхэлж, `//`-ээр эхлэхгүй»
 * ! шалгалт `/\evil.example`, `/<TAB>/evil.example`-ийг нэвтрүүлдэг байв:
 * ! URL задлагч `\`-г `/` гэж уншиж, TAB/CR/LF-ийг ХАСДАГ тул хоёулаа
 * ! `//evil.example` буюу гадаад сайт болдог (node-оор баталсан).
 *
 * ! Тиймээс: `/`-ээр эхэлнэ, `//` БИШ, `\` болон удирдах тэмдэгт БАЙХГҮЙ,
 * ! мөн задлагчаар шалгахад origin өөрчлөгдөхгүй — сүүлийнх нь давхар хаалт.
 */
export const safeNext = (next: string | null | undefined): string => {
  if (!next || !next.startsWith('/') || next.startsWith('//')) return '/'

  if (/[\\\p{Cc}]/u.test(next)) return '/'

  try {
    return new URL(next, PROBE_ORIGIN).origin === PROBE_ORIGIN ? next : '/'
  } catch {
    return '/'
  }
}

/**
 * Refine-ийн `?to=` — `useLogin` үүнийг провайдерын `redirectTo`-оос ТҮРҮҮЛЖ
 * дагадаг. Аюулгүй зам бол хэвээр, бусад үед `undefined`: тэгвэл `useLogin`
 * провайдерын `redirectTo: safeNext(next)`-д буцна (`/` рүү хүчээр биш).
 */
export const safeReturnTo = (to: unknown): string | undefined =>
  typeof to === 'string' && safeNext(to) === to ? to : undefined

/**
 * Хаягийн түлхүүрийг qs (Refine-ийн задлагч) `to` болгож нийлүүлэх эсэх.
 *
 * ! 🔴 `URLSearchParams.get('to')` ХАНГАЛТГҮЙ (FE-02). qs нь `to[]`, `to[0]`,
 * ! `to[x]`, `to[`, `[to]`-г бүгдийг `to` болгоно, `decodeURIComponent` нь
 * ! `['https://evil.example']`-ийг дахин мөр болгоно — `get('to')` нь `null`
 * ! өгч шалгалт огт ажиллахгүй байв. Дүрэм: эхний `[`-ээс өмнөх хэсэг, `[`-ээр
 * ! эхэлбэл эхний `[…]`-ийн доторх (qs 6.16; спек бодит qs-тэй тулгана).
 */
export const isQsToKey = (key: string): boolean => {
  const open = key.indexOf('[')

  if (open < 0) return key === 'to'

  return open > 0 ? key.slice(0, open) === 'to' : key.startsWith('[to]')
}
